import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import applyResponsiveVdpStyles from '../../../../../_shared/helpers/applyResponsiveVdpStyles';
import isOmpPlatform from '../../../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

/**
 * Variant Definitions
 */
const StyledCurrentBidVariants = {
  auctionEnded: css`
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  `
};

const StyledBidStateVariants = {
  modal: css`
    display: flex;
    flex-direction: row;
    margin: 0;
  `
};

const StyledUpcomingFloorPriceVariants = {
  mini: css`
    margin-left: 0;
    margin-top: 20px;
  `,
  expanded: css`
    margin-left: 15px;
  `
};

const StyledFloorPriceVariants = {
  upcoming: css`
    ${({ theme }) =>
      applyResponsiveVdpStyles(theme, {
        mini: StyledUpcomingFloorPriceVariants.mini,
        expanded: StyledUpcomingFloorPriceVariants.expanded
      })}
    align-self: flex-start;
  `
};

const NoBidsMessageMiniVdpVariants = {
  overview: css`
    margin-top: 10px;
    font-size: 28px;
  `
};

const NoBidsMessageVariants = {
  fr: css`
    font-size: 17px;
  `,
  mini: css`
    ${({ variant }) => NoBidsMessageMiniVdpVariants[variant]}
  `
};

const StyledBidStatusVariants = {
  overview: css`
    height: auto;
    max-height: 50px;
    padding: 0;
    justify-content: flex-start;
    border-top: 0;
    border-bottom: 0;
    background: ${({ theme }) => theme.COLORS.BASE};
  `
};

const StyledBadgesMiniVdpVariants = {
  overview: css`
    position: absolute;
    top: 18px;
    right: 12px;
    display: flex;
    margin-bottom: 20px;
    & > div {
      margin-left: -1px;
    }
  `
};

const StyledBadgesVariants = {
  mini: css`
    ${({ variant }) => StyledBadgesMiniVdpVariants[variant]}
  `
};

export const StyledBidStatus = styled.div`
  height: 72px;
  background: ${({ theme }) => theme.COLORS.NEUTRAL};
  border-top: 2px solid
    ${({ theme }) =>
      isOmp ? theme.COLORS.NEUTRAL_110 : theme.COLORS.NEUTRAL_50};
  border-bottom: 1px solid
    ${({ theme }) =>
      isOmp ? theme.COLORS.NEUTRAL_110 : theme.COLORS.NEUTRAL_50};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  ${({ theme, variant }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledBidStatusVariants[variant]
    })}
`;

const StyledFloorPrice = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  margin: 0px 10px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  align-self: center;

  ${({ variant }) => StyledFloorPriceVariants[variant]}
`;

StyledFloorPrice.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['upcoming', 'fr', 'en'])
};

StyledFloorPrice.defaultProps = {
  children: undefined,
  variant: undefined
};

export { StyledFloorPrice };

const StyledBidState = styled.div`
  margin-right: -6px;

  ${({ variant }) => StyledBidStateVariants[variant]}
`;

StyledBidState.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['modal', 'overview'])
};

StyledBidState.defaultProps = {
  children: undefined,
  variant: undefined
};

export { StyledBidState };

const StyledCurrentBid = styled.div`
  font-size: 28px;
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  white-space: nowrap;

  ${({ variant }) => StyledCurrentBidVariants[variant]}
`;

StyledCurrentBid.Wrapper = styled.div`
  text-align: left;
`;

StyledCurrentBid.NoBidsMessage = styled.div`
  font-size: 20px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};

  ${({ localeVariant }) => NoBidsMessageVariants[localeVariant]}
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: NoBidsMessageVariants.mini
    })}
`;

StyledCurrentBid.CurrentBid = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

StyledCurrentBid.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['auctionEnded'])
};

StyledCurrentBid.defaultProps = {
  children: undefined,
  variant: undefined
};

export { StyledCurrentBid };

export const StyledBadges = styled.div`
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledBadgesVariants.mini
    })}
`;

export const StyledBidModalTimer = styled.div`
  margin-left: 6px;
`;
